import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";

export const useAffiliate = () => {
  const [affiliate, setAffiliate] = useState<string | null>(null);
  const { user } = useAuth();

  const storageKey = `api.user.affiliate:${user?.profile?.sub}`;

  useEffect(() => {
    if (user?.profile?.sub) {
      const storedAffiliate = sessionStorage.getItem(storageKey);
      if (storedAffiliate) {
        setAffiliate(storedAffiliate);
      }
    }
  }, [user]);

  const setCurrentAffiliate = (affiliateId: string | null) => {
    if (affiliateId) {
      sessionStorage.setItem(storageKey, affiliateId);
      setAffiliate(affiliateId);
    }
  };

  return { currentAffiliate: affiliate, setCurrentAffiliate };
};
